import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  boxMenuFilter: {
    color: '#028B7E',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    width: '50%'
  },

  boxFormControl: {
    display: 'flex',
    alignItems: 'center'
  },
  checkbox: {
    marginLeft: 2,
    color: '#026873',
    '&.Mui-checked': {
      color: '#03A696'
    }
  },

  typographyBox: { width: 240, height: 50, paddingLeft: 1 },
  typography: {
    fontWeight: 'bold',
    fontFamily: 'Raleway',
    fontSize: '0.9em',
    letterSpacing: '0.03em',
    color: '#028B7E',
    '@media all and (max-width: 1250px)': {
      fontSize: '0.8em'
    }
  },
  typographyDate: {
    fontWeight: 'bold',
    fontFamily: 'Raleway',
    fontSize: '0.9em',
    letterSpacing: '0.03em',
    '&:hover': {
      fontSize: 14.8
    },
    '@media all and (max-width: 1250px)': {
      fontSize: '0.8em'
    }
  },
  arrowicon: {
    fontSize: '1em',
    // '&:hover': {
    //   fontSize: 14.8
    // },
    '@media all and (max-width: 1250px)': {
      fontSize: '1em'
    }
  },
  gridContainerInputSearch: {
    width: '100%',
    height: 33,
    boxShadow: 'inset 1px 1px 0 #BFBFBF,inset -1px 1px 0px #BFBFBF',
    zIndex: 1
  },
  gridCointanerInputSearch2: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 1
    // '@media all and (max-width: 900px)': {
    //   width: '70%'
    // }
  },
  input: {
    display: 'flex',
    backgroundColor: '#f2f2f2',
    alignItems: 'center',
    width: '100%',
    height: 31,

    '&:hover': {
      backgroundColor: '#fff',
      boxShadow: '0px 0px 3px 0px #0B7F75',
      WebkitBoxShadow: '0px 0px 3px 0px #0B7F75',
      MozBoxShadow: '0px 0px 3px 0px #0B7F75'
    }
  },
  buttonSearchInput: {
    paddingRight: '2%',
    fontWeight: 'bold',
    fontFamily: 'Raleway',
    fontSize: 14.5,
    letterSpacing: '0.03em',
    color: '#028B7E',
    cursor: 'pointer',
    '&:hover': {
      fontSize: 15,
      color: '#028B7E',
      textShadow: '0px 0px 1px #00FFAC'
    }
  },
  gridAddIcon: {
    width: '9%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  addIcon: { color: '#026873', cursor: 'pointer' },
  gridMenuType: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: '1em'
  },
  boxRestoreOption: {
    display: 'flex',
    color: '#606060',
    cursor: 'pointer',
    '&:hover': {
      color: '#028B7E'
    }
  },
  typographyOptions: {
    paddingLeft: '0.2em',
    fontWeight: 'bold',
    fontSize: '0.9em',
    letterSpacing: '0.03em',
    // color: '#606060',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}))

export default useStyles
